import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { BOX_IMG, CHECKOUT_URL } from './constants';
export function FinalCTA() {
  return <section className="py-8 px-4 sm:px-6 bg-petrol text-white text-center" data-id="element-38" data-mp="c6sklh6qa8cu">
      <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-gold uppercase leading-tight mb-3" data-id="element-39" data-mp="c4o6y7j11uzd">
        Un'Ultima Occasione
      </h2>

      <div className="max-w-2xl mx-auto text-[13px] sm:text-base text-cream/90 leading-relaxed space-y-2 mb-5" data-id="element-40" data-mp="m46pcjjah8pb">
        <p data-id="element-41" data-mp="h4u586jsyfqf">
          I tuoi clienti meritano allenamenti preparati con metodo, non lezioni
          improvvisate perché non hai avuto tempo di organizzarle.
        </p>
        <p data-id="element-42" data-mp="qvx5x78tksp6">
          Smetti di perdere ore ogni settimana tra esercizi, programmi,
          adattamenti e documentazione. Smetti di cercare materiale in decine di
          libri, PDF, video e corsi.
        </p>
        <p data-id="element-43" data-mp="zx4q6lei3t09">
          Inizia a lavorare con un sistema professionale già pronto, costruito
          per aiutarti a preparare ogni lezione in pochi minuti e offrire un
          servizio di livello superiore.
        </p>
        <p className="font-heading font-bold text-gold" data-id="element-44" data-mp="2h4j1qz36zuqq">
          Con SENIOR FITNESS COACH PRO™ avrai finalmente tutto ciò di cui hai
          bisogno in un'unica soluzione.
        </p>
      </div>

      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-4" data-id="element-45" data-mp="2r2ozr5lvogqb">
        <img src={BOX_IMG} alt="SENIOR FITNESS COACH PRO — Sistema Completo 6-in-1" className="w-full max-w-[200px] mx-auto object-contain drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-46" data-mp="302lunoyv2btt" />
      </a>

      <div className="bg-petrol-dark border border-gold/30 rounded-lg p-4 mb-4 max-w-md mx-auto" data-id="element-47" data-mp="39rvpvdp04am5">
        <p className="text-xs sm:text-sm font-heading font-bold uppercase tracking-wide text-white mb-1" data-id="element-48" data-mp="3et2wh9fer3r8">
          🏋️ SENIOR FITNESS COACH PRO™
        </p>
        <p className="text-[13px] text-cream/85 mb-2" data-id="element-49" data-mp="1jntsjwpbo3ze">
          Sistema Completo 6-in-1 + 5 Bonus Premium
        </p>
        <p className="text-sm text-cream/60 mb-0.5" data-id="element-50" data-mp="1eqbejrwg6ykj">
          Prezzo di Listino: <span className="line-through" data-id="element-51" data-mp="1sgez8efoik7v">97€</span>
        </p>
        <p className="text-3xl sm:text-4xl font-heading font-extrabold text-gold leading-none" data-id="element-52" data-mp="1sirmn747hmsb">
          Oggi Solo: 27€
        </p>
      </div>

      <div className="mb-2 max-w-lg mx-auto" data-id="element-53" data-mp="22ebe9hbqlzb9">
        <CTAButton data-id="element-54" data-mp="22d03uynsdtb6">🚀 SÌ! VOGLIO SENIOR FITNESS COACH PRO™</CTAButton>
      </div>
      <p className="text-[11px] sm:text-xs font-semibold text-cream/80 mb-3" data-id="element-55" data-mp="1xeymci60e21t">
        Accesso Immediato • Consegna Istantanea via Email
      </p>

      <TrustRow dark data-id="element-56" data-mp="27dxs9sze3jl4" />
    </section>;
}